angular.module('gestioneAttiApp').directive('respintoBlock', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/respintoBlock/respintoBlock.html',
        scope: {
            atto: '=',
            statoAttoCorrente: '=',
            respinto: '=',
            isProtocollo: '=',
            isSettoreAtti: '=',
            utente: "=",
            docTypes: "=",
            changeDocumentTypeCallback: "=",
            changeDocumentVisibilityCallback: "=",
            changeDocumentFrontpieceCallback: '=',
            publicView: "=",
            viewMode: '='
            
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Atto', 'User', 'PdlService', 'Documento', '$location','$anchorScroll', '$timeout', function (Atto, User, PdlService, Documento, $location, $anchorScroll, $timeout) {
            var vm = this;
            // vm.respinto = {visible: true};

            vm.sezioni = {
                RESPINTO: {
                    form: 'app/components/respintoBlock/respinto.html'
                }
            };

            vm.stato = {
                respinto: {
                    isCollapsed: vm.statoAttoCorrente === 'RESPINTO' || vm.viewMode
                }
            };

            vm.getSezioniFromMap = PdlService.getSezioniFromMap;
            vm.invalidFields = vm.invalidFields || [];
            //vm.utente = vm.currentUser;
        }]
    };
});
